import styled, { css } from "styled-components";

import { Button } from "../Button";

export const StyledIconButton = styled(Button)`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  width: 32px;

  ${({ size }) =>
    size === "small" &&
    css`
      width: 24px;
      svg {
        width: 18px;
        height: 18px;
      }
    `}

  ${({ size }) =>
    size === "big" &&
    css`
      width: 40px;
    `}
`;
